const KM_TO_MILE_FACTOR = 1.609;

export const kmToMiles = (km: number): number => {
    return km * KM_TO_MILE_FACTOR;
};

export default kmToMiles;
